// import Vue from 'vue'
import { LocalStorage } from 'quasar'

export function AUTH_LOADING (state, status) {
  state['loading'] = status
}

export function AUTH_SAVING (state, status) {
  state['saving'] = status
}

export function AUTH_CHECKED (state) {
  state['checked'] = true
}

export function AUTH_TOKEN_SET (state, token) {
  state['token'] = token
  LocalStorage.set('auth.token', token)
  LocalStorage.set('auth.freshLogin', true)
}

export function AUTH_VERIFICATION_CODE_SET (state, verificationCode) {
  state['verificationCode'] = verificationCode
}

export function AUTH_VERIFIED (state) {
  state['phoneVerified'] = true
}

export function AUTH_SET_LOCATION (state, location) {
  state['location'] = location
}

export function AUTH_LOGOUT (state) {
  if (state.token.length) {
    LocalStorage.remove('auth.token')
    state['token'] = ''
    window.location.reload()
  }
}

export function AUTH_STORE_ADDRESSES (state, addresses) {
  state['addresses'] = addresses
}

export function AUTH_STORE_USER (state, user) {
  state['user'] = user
}

export function SET_PRE_NUMBER (state, payload) {
  state.prePhone = payload.phone
  state.preCountryCode = payload.code
  state.preName = payload.name
  state.preCountry = payload.country
}

